import ACFBlockAmbassadors from './Components/ACFBlockAmbassadors';
import ACFBlockAmbassadorsSlideshow from './Components/ACFBlockAmbassadorsSlideshow';
import ACFBlockReadMore from './Components/ACFBlockReadMore';
import ACFBlockBeforeAfterPictures from './Components/ACFBlockBeforeAfterPictures';
import ACFBlockVideoSlideshow from './Components/ACFBlockVideoSlideshow';
import ACFBlockMediaTextVideo from './Components/ACFBlockMediaTextVideo';

import WPBlockVideo from './Components/WPBlockVideo';
import Accordion from './Components/Accordion';
import GoogleMap from './Components/GoogleMap';
import TrustpilotReviews from './Components/TrustpilotReviews';
import IntersectionObserverAnimations from './Components/IntersectionObserverAnimations';
import BlogPosts from './Components/BlogPosts';

import StickyBookingLink from "./Components/booking-link/StickyBookingLink.js";
import Prices from "./Components/acf-blocks/Prices.js";

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Manage IntersectionObservers
const intersectionObserverIsSupported = (!!window.IntersectionObserver || 'IntersectionObserver' in window);
if(intersectionObserverIsSupported) {
	document.body.classList.add('js-intersection-observer');
	new IntersectionObserverAnimations();
}

//
// Manage the Primary Menu
const togglePrimaryMenu = (e) => {
	if(e) {
		e.preventDefault();
	}
	document.body.classList.toggle('js-primary-menu-revealed');
}
document.querySelector('#primary-menu-toggler').addEventListener('click', togglePrimaryMenu);

//
// Manage the ACF Blocks
document.querySelectorAll('.acf-block-ambassadors').forEach(block => new ACFBlockAmbassadors(block));
document.querySelectorAll('.acf-block-ambassadors-slideshow,.acf-block-slideshow-text-image').forEach(block => new ACFBlockAmbassadorsSlideshow(block));
document.querySelectorAll('.acf-block-read-more').forEach(block => new ACFBlockReadMore(block));
document.querySelectorAll('.wp-block-media-text-wrapper[data-has-video="true"][data-poster-src]').forEach(block => new ACFBlockMediaTextVideo(block));
document.querySelectorAll('.acf-block-before-after-pictures').forEach(block => new ACFBlockBeforeAfterPictures(block));
document.querySelectorAll('.acf-block-video-slideshow').forEach(block => new ACFBlockVideoSlideshow(block));
document.querySelectorAll('.acf-block-prices .price-item').forEach(block => new Prices(block));

//
// Manage the Core WP Blocks
document.querySelectorAll('.wp-block-video-wrapper').forEach(block => new WPBlockVideo(block));

//
// Manage the other content
document.querySelectorAll('.trustpilot-reviews').forEach(reviews => new TrustpilotReviews(reviews));
document.querySelectorAll('.google-map').forEach(mapEl => new GoogleMap(mapEl));
document.querySelectorAll('.accordions .accordion').forEach(accordion => new Accordion(accordion));

//
// Manage the BlogPosts
const blogPosts = document.querySelector('.blog-posts');
if(blogPosts) {
	new BlogPosts(blogPosts);
}

//
// Manage the Primary Menu
const mediaQuery = window.APP_Localize.mediaquery; // From theme-setup
const primaryMenuItems = document.querySelectorAll('#menu-1 .menu-item');
primaryMenuItems.forEach((menuItem) => {
	const subMenu = menuItem.querySelector('.sub-menu');
	if(subMenu) {

		// No touch devices
		menuItem.addEventListener('mouseover', (e) => {
			if(!Modernizr.touchevents && window.innerWidth >= mediaQuery.lg) {
				e.currentTarget.classList.add('js-reveal-submenu');
				document.body.classList.add('js-primary-menu-dropdown-revealed');
			}
		});
		menuItem.addEventListener('mouseleave', (e) => {
			if(!Modernizr.touchevents && window.innerWidth >= mediaQuery.lg) {
				e.currentTarget.classList.remove('js-reveal-submenu');
				document.body.classList.remove('js-primary-menu-dropdown-revealed');
			}
		});

		// Touch devices
		menuItem.querySelector('a:first-child').addEventListener('click', (e) => {

			if(Modernizr.touchevents || window.innerWidth < mediaQuery.lg) {

				e.preventDefault();

				const menuItem = e.currentTarget.parentNode;

				if(menuItem.classList.contains('js-reveal-submenu')
					|| menuItem.classList.contains('current-menu-parent')
					|| ( menuItem.classList.contains('current_page_item') && menuItem.classList.contains('menu-item-has-children') ) ) {

					// If it's already revealed we want to go to the page on the next click (on mobile)
					if(window.innerWidth >= mediaQuery.lg) {
						e.preventDefault();

						if(menuItem.classList.contains('js-reveal-submenu')) {
							menuItem.classList.remove('js-reveal-submenu');
							document.body.classList.remove('js-primary-menu-dropdown-revealed');
						}
						else {
							menuItem.classList.add('js-reveal-submenu');
							document.body.classList.add('js-primary-menu-dropdown-revealed');
						}
					}
					else {
						e.preventDefault();

						if(( menuItem.classList.contains('current-menu-parent') && menuItem.classList.contains('menu-item-has-children'))) {
							if(menuItem.classList.contains('js-conceal-submenu')) {
								menuItem.classList.add('js-reveal-submenu');
								menuItem.classList.remove('js-conceal-submenu');
							}
							else {
								menuItem.classList.remove('js-reveal-submenu');
								menuItem.classList.add('js-conceal-submenu');
							}
						}
						else {
							if(menuItem.classList.contains('js-reveal-submenu')) {
								menuItem.classList.remove('js-reveal-submenu');
								menuItem.classList.add('js-conceal-submenu');
							}
							else {
								menuItem.classList.add('js-reveal-submenu');
								menuItem.classList.remove('js-conceal-submenu');
							}
						}
					}
				}
				else {
					menuItem.classList.add('js-reveal-submenu');
					if(window.innerWidth >= mediaQuery.lg) {
						document.body.classList.add('js-primary-menu-dropdown-revealed');
					}
				}
			}
		});
	}
});

//
// Cookie information
let nage21_cookie_cat_statistic_1st_load = false;
let nage21_cookie_cat_marketing_1st_load = false;

window.addEventListener('CookieInformationConsentGiven', (e) => {
	if(CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {

		const blocksOptoutStatistic = document.querySelectorAll('.cookieconsent-optout-statistic');
		blocksOptoutStatistic.forEach((block) => {
			block.style.display = 'none';
		})
		if(!nage21_cookie_cat_statistic_1st_load) {
			nage21_cookie_cat_statistic_1st_load = true;
		}
	}

	if(CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
		const blocksOptoutMarketing = document.querySelectorAll('.cookieconsent-optout-marketing');
		blocksOptoutMarketing.forEach((block) => {
			block.style.display = 'none';
		})
		if(!nage21_cookie_cat_marketing_1st_load) {
			nage21_cookie_cat_marketing_1st_load = true;
		}
	}

}, false);

//
// Single post lazy load
if(document.body.classList.contains('single-post'))
{
	const images = document.querySelectorAll('img');
	if(images && images.length > 0) {
		images.forEach(img => {
			img.setAttribute('loading', 'lazy');
			img.setAttribute('fetchpriority', 'low');
		})
	}
}

new StickyBookingLink();